import { defineComponent, createBlock, createCommentVNode, unref, openBlock, resolveDynamicComponent } from "vue";
import { isFilled } from "@prismicio/client";
const defaultWrapper = "div";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{ name: "PrismicEmbed" },
  __name: "PrismicEmbed",
  props: {
    field: {},
    wrapper: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return unref(isFilled).embed(_ctx.field) ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.wrapper || defaultWrapper), {
        key: 0,
        "data-oembed": _ctx.field.embed_url,
        "data-oembed-type": _ctx.field.type,
        "data-oembed-provider": _ctx.field.provider_name,
        innerHTML: _ctx.field.html
      }, null, 8, ["data-oembed", "data-oembed-type", "data-oembed-provider", "innerHTML"])) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=PrismicEmbed.vue.js.map
